module.exports = __webpack_public_path__ + "static/media/upload_placeholder.53258b47.png";